import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { getCurrentUser, fetchUserAttributes } from "aws-amplify/auth";
import { useLazyQuery, gql, useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";

const GET_TECHNICIAN = gql`
  query MyQuery($id: uuid!) {
    technician_by_pk(id: $id) {
      name
      email
    }
  }
`;

const ADD_TECHNICIAN = gql`
  mutation AddTechnician($id: uuid!, $name: String!, $email: String!) {
    insert_technician_one(object: { id: $id, name: $name, email: $email }) {
      id
      name
      email
    }
  }
`;

const Initialize = () => {
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(null);
  const navigate = useNavigate();
  const [getTechnician, { data, refetch }] = useLazyQuery(GET_TECHNICIAN);
  const [addTechnician] = useMutation(ADD_TECHNICIAN);

  useEffect(() => {
    async function loginVerification() {
      try {
        const { userId } = await getCurrentUser();
        console.log(`The userId: ${userId}`);
        setUserId(userId);
        getTechnician({ variables: { id: userId } });
      } catch (err) {
        console.log(err);
      }
    }
    loginVerification();
  }, [getTechnician]);

  useEffect(() => {
    if (data && !data.technician_by_pk) {
      const addUser = async () => {
        const { email } = await fetchUserAttributes();
        const username = getUsername(email);
        await addTechnician({
          variables: { id: userId, name: username, email },
        }).then(async () => {
          await refetch();
          setLoading(false);
        });
      };
      addUser();
    } else if (data && data.technician_by_pk) {
      setLoading(false);
    }
  }, [data, addTechnician, userId, refetch]);

  useEffect(() => {
    if (!loading) {
      navigate("/project_list");
    }
  }, [loading, navigate]);

  const getUsername = (email) => {
    const username = email.split("@")[0];
    return username.charAt(0).toUpperCase() + username.slice(1);
  };

  return (
    <div>
      <Spin spinning={loading} fullscreen />
    </div>
  );
};

export default Initialize;
